<template>
  <PflegeAlert
    v-editable="props.blok"
    :heading="props.blok.heading"
    :variant="calcedVariant"
    class="alertbox"
    :data-uid="props.blok._uid"
  >
    <WizcoRichtextResolver :blok="props.blok.content" />
  </PflegeAlert>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  blok: {
    type: Object,
    required: true
  }
})

const calcedVariant = computed(() => {
  return props.blok.variant === '' || !props.blok.variant ? 'info' : props.blok.variant
})
</script>
